import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const getOrders = () => axios.get(`${BASE_URL}/orders`, authHeader());
export const getOrder = (orderId) => axios.get(`${BASE_URL}/orders/${orderId}`, authHeader());
export const createOrder = (addressId) => axios.post(`${BASE_URL}/orders`, { addressId }, authHeader());
export const cancelOrder = (orderId) => axios.patch(`${BASE_URL}/orders/${orderId}/cancel`, {}, authHeader());
export const getAddresses = () => axios.get(`${BASE_URL}/orders/addresses`, authHeader());
export const addAddress = (addressData) => axios.post(`${BASE_URL}/orders/addresses`, addressData, authHeader());